import { WorkOrderItemType } from "features/WorkOrders/constants/work-order-item.constants";
import type { PettyWorkItem } from "features/PettyWorks/types/petty-work.types";
import { pettyWorkLineQuantity } from "features/PettyWorks/utils/petty-work.utils";
import { QuotationItemType } from "features/Quotations/constants/quotation.constants";
import type { QuotationItemFormRow } from "features/Quotations/utils/quotationItem.utils";

function pettyLineTypeToQuotationType(
  raw: PettyWorkItem["type"],
): QuotationItemType {
  if (
    raw === WorkOrderItemType.MATERIAL ||
    raw === WorkOrderItemType.LABOR ||
    raw === WorkOrderItemType.SERVICE
  ) {
    return raw as QuotationItemType;
  }
  return QuotationItemType.MATERIAL;
}

/** Map petty work BOQ lines into rows for {@link BoqItemsFieldArray} / quotation BOQ shape. */
export function pettyWorkItemsToMrBoqRows(
  items: PettyWorkItem[] | null | undefined,
): QuotationItemFormRow[] {
  const rows = items ?? [];
  if (rows.length === 0) return [];
  return rows.map((item) => {
    const type = pettyLineTypeToQuotationType(item.type);
    const qty = pettyWorkLineQuantity(item);
    const rateRaw =
      item.rate != null ? item.rate : (item.product?.standardRate ?? 0);
    const rate = Number.isFinite(Number(rateRaw)) ? Number(rateRaw) : 0;
    const description =
      String(item.description ?? "").trim() ||
      item.product?.name?.trim() ||
      "";
    const unit =
      String(item.unit ?? "").trim() ||
      item.product?.uom?.code?.trim() ||
      item.product?.uom?.name?.trim() ||
      "";
    const pid = item.productId;
    const id =
      item.id != null && Number.isFinite(Number(item.id)) && Number(item.id) > 0
        ? Number(item.id)
        : undefined;
    return {
      ...(id != null ? { id } : {}),
      type,
      description:
        description || (pid != null && Number(pid) > 0 ? `Product #${pid}` : ""),
      productId: pid != null && Number(pid) > 0 ? Number(pid) : "",
      quantity: qty > 0 ? qty : 1,
      unit,
      rate,
    };
  });
}
